import Vue from 'vue';
import Vuex from 'vuex';

import auth from './modules/auth/auth';
import cart from './modules/cart/cart';
import countries from './modules/countries/countries';
import event from './modules/event/event';
import navigation from './modules/navigation/navigation';
import payment from './modules/payment/payment';
import products from './modules/products/products';
import state from './modules/state/state';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    cart,
    countries,
    event,
    navigation,
    payment,
    products,
    state,
  },
  state: {},
  mutations: {},
  actions: {},
  getters: {},
});
